module.exports = __webpack_public_path__ + "static/media/betsoft.6bb9f3b3.jpeg";